import React, { Component } from 'react'; 
import Toggle from "react-toggle";
import axios from '../../../../../axios';
import * as url from '../../../../../utils/url';
import findIndex from 'lodash/findIndex';
import Checkbox from 'rc-checkbox';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux'; 
import * as actionCreators from '../../../../../modules/actions/index';
import moment from 'moment';
import AttendeeItem from './AttendeeItem';
import {groupContentFields, groupPrivacyStatusDesc,uploadPreview,whiteLabelStyling} from  '../../../../../utils/constants';
import { Modal, ModalBody,ModalHeader, Alert, Button, Label, Dropdown, DropdownItem, DropdownToggle, DropdownMenu, Row, Col, Input } from 'reactstrap'

class EventAttendees extends Component {

	constructor(props) {
    super(props);
			this.state = { 
				users:[],
        isSuccess:false,removedItem:null
		  }
    }


componentDidMount(){
  let payload ={
    eventId:this.props.match.params.id, 
    organizationId: this.props.item.organizationID
  }
  let that=this
  axios.post(url.findEventGuests,  payload).then(resp => {
    that.setState({
      users: resp.data.data
    })
  }).catch(error => {
     console.log(error);
     this.setState({error: true, errorMessage: 'Failed to add tool. Please try again.'});
  });
    
}
 


renderMembers = (tasks) => {
  let{users,isSuccess,removedItem}=this.state

  return (
        <span>
          {isSuccess? <Alert color="success" isOpen={isSuccess} toggle={this.onDismiss}>
                        <strong>{removedItem.name}</strong> was removed.
                      </Alert> :null}

            <div className="list" id="list" data-searchable="data-searchable">

            <ul className="responsive-table">
                  <li className="table-header dashboardHeader" 
                    // style={whiteLabelStyling(['backgroundColor'], this.props.user.profile.organizationId)}
                    >
                    <div className="col col-6">Profile</div>
                    <div className="col col-5">Role</div>
                    {/* <div className="col col-4">Date Joined</div> */}
                    <div className="col col-1"></div>
                  </li>


                  { users.map((item,idx) => {
                      return <AttendeeItem 
                      {...this.state}
                      single_member={item} key={item._id+idx}/>
                  })}
                
                </ul>
                  
            </div>
        </span> 
      )
};
 

	render() {
       let{users}=this.state

       return (<span className="event_details_page_attendees_section"> 
                 <div className="event_details_page_attendees_section_containers_meta">

                    {/* <div className="event_details_page_about_section_containers">
                        <span className="grp_create_page_privacy_status_details title">
                        Attendees
                        </span>

                    </div>   */}


              
        {this.renderMembers()}
                    {/* <div className="event_details_page_about_section_containers">
                        <span className="grp_create_page_privacy_status_details title">
                            Relevant Links/attachments
                        </span>
                        <div className="taskUploadPreviewContainer mb0">
                                 
                        </div>
                    </div>     */}



                    </div>   

             </span>)
	}
}

const mapStateToProps = state => {
	return {
    user: state.user.profile,
	};
};


const mapDispatchToProps = dispatch => {
	return {
	  storyMetricsChange: (data) => dispatch(actionCreators.storyMetricsChange(data)),
	}
  }


export default withRouter(connect(mapStateToProps, mapDispatchToProps)(EventAttendees));


  
  